import { render } from "./MultiSelectWrapper.vue?vue&type=template&id=67008fd2"
import script from "./MultiSelectWrapper.vue?vue&type=script&lang=js"
export * from "./MultiSelectWrapper.vue?vue&type=script&lang=js"

import "./MultiSelectWrapper.vue?vue&type=style&index=0&id=67008fd2&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__